import * as Yup from 'yup'
import {Email} from 'Validations'

const Validation = Yup.object().shape({
  newEmail: Email,
})

export default Validation
